import React from 'react';
import './TrustSection.css';

const TrustSection = () => {
  const trustCards = [
    {
      icon: '🛡️',
      title: 'Verified Businesses',
      desc: 'Mandatory GSTIN, PAN, and BIS hallmarking license verification for all buyers and sellers before onboarding.',
    },
    {
      icon: '📋',
      title: 'Structured Product Information',
      desc: 'Standardized digital cataloguing detailing gross weight, net metal weight, gemstone deductions, and hallmark standards.',
    },
    {
      icon: '📍',
      title: 'Order-Level Tracking',
      desc: 'Milestone custody audits from factory order acceptance through staging, vaulting, transit, and physical delivery.',
    },
    {
      icon: '🧾',
      title: 'Digital Transaction Records',
      desc: 'Immutable digital proforma, tax invoices, weighing slips, and payment reconciliations archived for tax compliance.',
    },
    {
      icon: '🔐',
      title: 'Controlled Fulfilment',
      desc: 'Transit conducted through vetted bullion logistics partners utilizing tamper-evident barcoded custody bags.',
    },
    {
      icon: '🏛️',
      title: 'Business-to-Business Network',
      desc: 'Strictly restricted to licensed commercial jewellery enterprises, preventing retail noise and protecting wholesale pricing.',
    },
  ];

  return (
    <section className="trust-section" id="trust">
      <div className="jmi-container">
        <div className="section-header-center">
          <div className="section-label">OPERATIONAL GOVERNANCE</div>
          <h2 className="section-title">
            Built for <span className="gold-gradient-text">High-Value B2B Transactions</span>
          </h2>
          <p className="section-subtitle">
            Wholesale bullion and diamond trade demands operational discipline, verifiable documentation,
            and complete custody transparency at every stage of exchange.
          </p>
        </div>

        <div className="trust-cards-grid">
          {trustCards.map((card, idx) => (
            <div key={idx} className="trust-card-item">
              <div className="trust-icon-box">{card.icon}</div>
              <h3 className="trust-card-title">{card.title}</h3>
              <p className="trust-card-desc">{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
